import DE from '../assets/languages/de.svg';
import EN from '../assets/languages/en.svg';
import ES from '../assets/languages/es.svg';
import FR from '../assets/languages/fr.svg';
import IT from '../assets/languages/it.svg';

export const LANGUAGE_FLAGS: Record<string, string> = {
  en: EN,
  de: DE,
  es: ES,
  fr: FR,
  it: IT,
};

export const LANGUAGES = ['en', 'de', 'fr', 'es', 'it'];
